import React from "react";
import { useParams } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { resolveDsokCustomerDetailView } from "../resolver/resolveDsokCustomerDetailView";
import SectionResolver from "../sections/SectionResolver";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";
import { Box, Button } from "@mui/material";

/** True if any device has the ALBACON/Glory cash machine enabled. */
const hasAlbaconEnabled = (dsokSettings) => {
  const devices = dsokSettings?.customer?.devices;
  const list = Array.isArray(devices)
    ? devices
    : devices && typeof devices === "object"
      ? Object.values(devices)
      : [];
  return list.some((d) => d?.orderProcess?.enableCashMachine === true);
};

const DsokCustomerDetailPage = () => {
  const { customerUrl } = useParams();
  const { customer, dsokSettings } = useDsokCustomerDetail();
  const auth = useJumboAuth();
  const authUser = auth?.getAuthUser?.() || {};
  const userTyp = authUser?.type ?? authUser?.typ;
  const customerType = authUser?.customer?.customerType ?? authUser?.customer?.customer_type;
  const typ = customerType === 7 ? 7 : userTyp;

  const ViewComponent = resolveDsokCustomerDetailView(typ);

  const albaconEnabled = hasAlbaconEnabled(dsokSettings);
  const albaconCustomerId = dsokSettings?.customer?.customerId ?? customerUrl;

  return (
    <DsokCustomerDetailLayout>
      <Box sx={{ px: 0 }}>
        {albaconEnabled && (
          <Box sx={{ mb: 1 }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() =>
                window.open(
                  `/customer/dsok/albacon-simulator/${albaconCustomerId}`,
                  "_blank",
                )
              }
            >
              Albacon simulátor kiosku (test)
            </Button>
          </Box>
        )}
        <SectionResolver customerType={typ} customerUrl={customerUrl} />
        <ViewComponent />
      </Box>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerDetailPage;
